import { httpService } from '@commons';

export function findUsuarioProdutorDetails(id) {
  return httpService.getApiManager(`/userAuth/details/${id}`, true);
}

export function filterUsuarioProdutor(where, page, rows) {
  return httpService.getApiManager(
    `/userAuth/listAll?page=${page}&size=${rows}${where}`,
    true,
  );
}
